import { action, makeAutoObservable, observable } from 'mobx';
import { createContext } from 'react';

/**
 * GAなどで利用するトラッキング用のグローバルストア
 * departmentやtreatmentKindなど、複数ページに跨って参照したい値を保持する
 */
export class TrackingStore {
  public static Context = createContext<TrackingStore | null>(null);

  /**
   * 診療科ID
   */
  public department?: string;

  /**
   * 診療内容種別ID
   */
  public treatmentKind?: string;

  /**
   * トラッキング情報が設定されているかどうか
   */
  public isTrackingReady = false;

  constructor() {
    makeAutoObservable(this, {
      department: observable,
      treatmentKind: observable,
      setDepartment: action,
      setTreatmentKind: action,
      setTrackingInfo: action,
      isTrackingReady: observable,
      resetTrackingReady: action,
    });
  }

  public setDepartment(department?: string | null) {
    this.department = department ?? undefined;
  }

  public setTreatmentKind(treatmentKind?: string | null) {
    this.treatmentKind = treatmentKind ?? undefined;
  }

  public setTrackingInfo(department?: string | null, treatmentKind?: string | null) {
    this.setDepartment(department);
    this.setTreatmentKind(treatmentKind);
    this.isTrackingReady = true;
  }

  public resetTrackingReady() {
    this.isTrackingReady = false;
  }
}
